export default __webpack_public_path__ + "static/media/img_company_header24.3b7de63c.png";